/**
 * SupportRequest — the standalone support queue; no relations to any other
 * entity by design. This is the working draft the shape starts from — the
 * final shape, including whether customers create directly and under which
 * permission, is a later catalog decision (16).
 *
 * Path: `workspaces/{orgId}/supportRequests/{id}` — member CRUD.
 *
 * NO `entity()`/policy lands in this file — SupportRequest's policy is
 * deferred; the shape above is the working draft. Schema only for now; the
 * path falls to the generated default-deny tail.
 */
import type { Timestamp } from "firebase/firestore";
import { z } from "zod";

// `closedAt` rather than a status enum: open ⟺ closedAt == null, and the
// timestamp additionally yields resolution time, which 16 wants alongside
// the queue. Explicit-null is the repo convention for absence, so a
// member "open queue" query filters closedAt == null directly.
export const SupportRequestSchema = z.object({
	email: z.string().email(),
	subject: z.string().min(1),
	body: z.string().min(1),
	assignee: z.string().nullish(),
	createdAt: z.custom<Timestamp>(),
	respondedAt: z.custom<Timestamp>().nullish(),
	closedAt: z
		.custom<Timestamp>()
		.nullish()
		.describe(
			"null while the request is open — with createdAt and respondedAt this carries first-response and resolution time without a second field",
		),
});
export type SupportRequest = z.infer<typeof SupportRequestSchema>;
